export const toss = (error: Error): never => {
    throw error;
};
